module.exports = __webpack_public_path__ + "img/Saderat.3e9d13fc.svg";